import React, { useEffect } from "react";
import AOS from 'aos';
import { Route, Routes } from "react-router-dom";
import HomeOne from '../components/Home/HomeOne/Main';
import HomeTwo from '../components/Home/HomeTwo/Main';
import HomeThree from '../components/Home/HomeThree/Main';
import HomeFour from '../components/Home/HomeFour/Main';
import HomeFive from "../components/Home/HomeFive/Main";
import Aboutus from '../components/Pages/Aboutus/Main';
import Careers from '../components/Pages/Careers/Main';
import Team from "../components/Pages/Team/Main";
import Testimonial from "../components/Pages/Testimonial/Main";
import Pricing from "../components/Pages/Pricing/Main";
import Services from '../components/Service/Services/Main';
import ServiceDetails from '../components/Service/ServiceDetails/Main';
import Portfolio from '../components/Portfolio/Portfolio/Main';
import Details from '../components/Portfolio/Details/Main';
import Blog from '../components/Blog/Blog/Main';
import BlogDetail from '../components/Blog/BlogDetails/Main';
import Shop from '../components/Shop/Shop/Main';
import ProdectDetails from '../components/Shop/ProdectDetails/Main';
import Cart from '../components/Shop/Cart/Main';
import CheckOut from '../components/Shop/CheckOut/Main';
import ContactUs from '../components/Contact/Main';

const Index = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    })
    return (
        <Routes>
            <Route path="/" element={<HomeOne />} />
            <Route path="/HomeTwo" element={<HomeTwo />} />
            <Route path="/HomeThree" element={<HomeThree />} />
            <Route path="/HomeFour" element={<HomeFour />} />
            <Route path='/HomeFive' element={<HomeFive />} />
            <Route path="/Aboutus" element={<Aboutus />} />
            <Route path="/Careers" element={<Careers />} />
            <Route path="/team" element={<Team />} />
            <Route path="/Testimonial" element={<Testimonial />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/ServiceDetails" element={<ServiceDetails />} />
            <Route path="/Portfolio" element={<Portfolio />} />
            <Route path="/Details" element={<Details />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/BlogDetails" element={<BlogDetail />} />
            <Route path="/Shop" element={<Shop />} />
            <Route path="/ProdectDetails" element={<ProdectDetails />} />
            <Route path="/Cart" element={<Cart />} />
            <Route path="/CheckOut" element={<CheckOut />} />
            <Route path="/Contact" element={<ContactUs />} />
        </Routes>
    )
}

export default Index